<template>
  <div class="section-bills-list section-full">
    <h2 class="ttl2 popup-header" v-translate>list of open bills</h2>
    <div class="d-flex pb-1">
      <div class="col-6">
        <span v-translate>Total open bills: </span> <strong>{{ bills.length }}</strong>
      </div>
      <div class="col-6 text-right">
        <span v-translate>Total: </span> <strong>{{ totalAmount | currency }}</strong>
      </div>
    </div>
    <bills-table :bills="bills" :openOnly="true" @billClicked="setBill"/>
  </div>
</template>

<script>
import BillsTable from '@/components/BillsTable.vue';
import {
  SET_MESSAGE_MODAL,
} from "@/store/mutation-types";
export default {
  name: 'BillsOpen',
  components: {
    BillsTable,
  },
  computed: {
    bills() { 
      return this
              .getArray('bills')
              .filter(bill => bill.status == this.OPEN_STATUS)
              .reverse() 
    },
    totalAmount() {
      let amount = 0;
      this.bills.forEach((item) => {
        amount += item.amount;
      });
      return amount;
    },
    shift() { return this.getMap('user', true).shift }
  },
  methods: {
    setBill(bill) {
      if(!this.shift) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Please start shift")
        );
      } else {
        this.$store.state.bill.payCash = '';
        this.$store.dispatch('setBill', Object.assign({}, bill));
        this.$router.push({ name: 'order' });
      }
    },
  },
};
</script>
